import { InjectableClass } from '@fino/lib-injection';

export class SignaturePadService extends InjectableClass {
  constructor($window) {
    'ngInject';
    super({ $window });
  }

  // Returns a cropped image from the given canvas context or null if the canvas is blank
  getCroppedSignature(width, height, ctx, skipCheckAspectRatio) {
    let image = ctx.getImageData(0, 0, width, height);
    let getAlphaValue = function (x, y) {
      return image.data[(width * y + x) * 4 + 3];
    };
    let scanY = function (fromTop) {
      let offset = fromTop ? 1 : -1;

      // loop through each row
      for (
        var y = fromTop ? 0 : height - 1;
        fromTop ? y < height : y > -1;
        y += offset
      ) {
        // loop through each column
        for (var x = 0; x < width; x++) {
          if (getAlphaValue(x, y)) {
            return y;
          }
        }
      }
      return null; // all image is white
    };
    let scanX = function (fromLeft) {
      let offset = fromLeft ? 1 : -1;

      // loop through each column
      for (
        var x = fromLeft ? 0 : width - 1;
        fromLeft ? x < width : x > -1;
        x += offset
      ) {
        // loop through each row
        for (var y = 0; y < height; y++) {
          if (getAlphaValue(x, y)) {
            return x;
          }
        }
      }
      return null; // all image is white
    };

    let cropTop = scanY(true);
    let cropBottom = scanY(false);
    let cropLeft = scanX(true);
    let cropRight = scanX(false);

    if (!cropTop && !cropBottom && !cropLeft && !cropRight) {
      // canvas is blank
      return null;
    }

    let croppedWidth = cropRight - cropLeft;
    let croppedHeight = cropBottom - cropTop;
    // Make sure the signature has a minimum size to prevent ugly results
    let minimumWidth = 200;
    if (croppedWidth < minimumWidth) {
      cropLeft -= (minimumWidth - croppedWidth) / 2;
      croppedWidth = minimumWidth;
    }
    // check aspect ratio per default, it can be disabled since there is often space between signature and (top/bottom)
    if (!skipCheckAspectRatio) {
      let aspectRatio = 3 / 2;
      if (croppedWidth / croppedHeight < aspectRatio) {
        let prevCroppedWidth = croppedWidth;
        croppedWidth = croppedHeight * aspectRatio;
        cropLeft -= (croppedWidth - prevCroppedWidth) / 2;
      } else {
        let prevCroppedHeight = croppedHeight;
        croppedHeight = croppedWidth * (1 / aspectRatio);
        cropTop -= (croppedHeight - prevCroppedHeight) / 2;
      }
    }
    let croppedImage = ctx.getImageData(
      cropLeft,
      cropTop,
      croppedWidth,
      croppedHeight
    );
    // Possible without a new canvas?
    let tmpCanvas = this.$window.document.createElement('canvas');
    tmpCanvas.width = croppedWidth;
    tmpCanvas.height = croppedHeight;
    tmpCanvas.getContext('2d').putImageData(croppedImage, 0, 0);
    return tmpCanvas.toDataURL();
  }

  fitReceivedSignatureToSignaturePad(canvas, base64, callback) {
    const fitImage = new Image();
    fitImage.onload = () => {
      let height;
      let width;
      let ratio = 0;

      if (fitImage.width >= canvas.width) {
        ratio = canvas.width / fitImage.width;
        width = fitImage.width * ratio;
        height = fitImage.height * ratio;
      } else {
        width = fitImage.width;
      }

      if (fitImage.height >= canvas.height) {
        ratio = canvas.height / fitImage.height;
        width = fitImage.width * ratio;
        height = fitImage.height * ratio;
      } else {
        height = fitImage.height;
      }
      // draw the image in the center of the canvas
      canvas
        .getContext('2d')
        .drawImage(fitImage, canvas.width / 2 - width / 2, 0, width, height);
      callback(canvas.toDataURL());
    };
    fitImage.src = base64;
  }

  generateSignature(canvas, clientName) {
    let context = canvas.getContext('2d');
    let fontSize = canvas.width / 6.5 / clientName.length;
    fontSize = (fontSize > 8.0 ? 8.0 : fontSize) * 8.0;

    context.font = `${fontSize}px ApplauseFont`;
    context.fillStyle = '#334499';
    context.fillText(clientName, canvas.width / 6, canvas.height / 3.5);
  }
}
